import { useMutation, useQueryClient } from "react-query";
import axios from "axios";

export const useUpdatePendingDirectDataImport = () => {
  const queryClient = useQueryClient();
  return useMutation(
    async ({
      pendingDirectDataImportId,
      previewName,
      schemaExtractorOutline,
      fileNameInGcs,
      kp_content_type,
      metadata,
    }) => {
      const { data } = await axios.put(
        `/api/content/updatePendingDirectDataImport/${pendingDirectDataImportId}`,
        {
          previewName,
          schemaExtractorOutline,
          fileNameInGcs,
          kp_content_type,
          metadata,
        }
      );
      return data;
    },
    {
      // Hook-level so it survives the caller unmounting mid-request (the
      // import modal closes itself right after a successful save). The
      // pending-imports list caches for 5 min (staleTime); without this the
      // just-updated pending import doesn't refresh in it.
      onSettled: () =>
        queryClient.invalidateQueries("pendingDirectDataImports"),
    }
  );
};
